import { contractorApi } from '@/lib/api'

import { ContractorTaxForm } from '../types'

export function getContractorTaxForm({ taxFormId }: { taxFormId: string }) {
  return contractorApi.get<ContractorTaxForm>(
    `/v1/my/displayable-tax-forms/${taxFormId}`,
  )
}
